import { useHistory } from 'react-router';
import { useEffect, useState } from 'react';

//STYLES
import { Container } from './styles';

//APP
import { useLogic } from '../../../../context/useLogic';
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado';
import { useGetPedidoLaboratorio } from '../../../../services/AgriculturaPrecisao/bookResumido/GET';
import { processarMapasFertilidade } from './meta';

//COMPONENTS
import ViewPage from '../../../../Components/ViewPage';
import { TitleH1 } from '../../../../Components/CustomUi/titleH1';
import { TabelaMapaFertilidadeResumido } from './components/tabelaMapas';

function MapaFertilidadeResumido() {

  //CONSTS
  const history = useHistory();
  const { checkSafra } = useLogic();

  //STATES
  const [_permissions, setPermissions] = useState<ItensPerUserLogged>(); //nosonar

  //API
  const { data_pedidos, carregando_pedidos } = useGetPedidoLaboratorio();

  useEffect(() => {

    const idDaSafra = checkSafra('/precisao/book-fertilidade-agrupado')

    if (!idDaSafra) {
      history.push('/home')
    }
  }, [])

  return (
    <Container>
      <ViewPage
        onPermission={setPermissions}
        rotina={82}
        newHide
        title='Gerar book de Fertilidade resumido'
        btnClick={() => {}}
        content={null}
        hiddeTitle
        cardBodyStyle={{padding: 15}}
        cardMainStyle={{height: '87.5vh'}}
      >
        <TitleH1>Gerar book de fertilidade agrupado</TitleH1>
        
        <TabelaMapaFertilidadeResumido 
          lista_propriedades={processarMapasFertilidade(data_pedidos)}
          carregando_pedidos={carregando_pedidos}
        />

      </ViewPage>
    </Container>
  )
}

export default MapaFertilidadeResumido;
